import styled from 'styled-components';
import type { PtoVolumePosition } from '@shared/api';
import { visibleColumns, type VolumeCellContext } from './columns';
import { VolumeRow } from './VolumeRow';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    text-align: left;
    padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(2.5)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    vertical-align: top;
  }

  th {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 600;
    white-space: nowrap;
  }

  th.wrap {
    white-space: normal;
    min-width: 96px;
  }

  td.num {
    text-align: right;
    white-space: nowrap;
  }
`;

interface Props {
  positions: PtoVolumePosition[];
  ctx: VolumeCellContext;
  /** Позиция, открытая по ссылке на строку; null — нет. */
  targetId: string | null;
}

/** Таблица позиций объёма: заголовки и ячейки граф — из `VOLUME_COLUMNS`. Строки —
 *  в порядке ответа API (порядок РД); экран их не сортирует. */
export function VolumesTable({ positions, ctx, targetId }: Props) {
  const columns = visibleColumns(ctx);
  return (
    <Table>
      <thead>
        <tr>
          {columns.map((c) => (
            <th key={c.key} className={c.num ? 'num' : c.wrap ? 'wrap' : undefined}>
              {c.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {positions.map((p) => (
          <VolumeRow
            key={p.id}
            position={p}
            columns={columns}
            ctx={ctx}
            target={p.id === targetId}
          />
        ))}
      </tbody>
    </Table>
  );
}
